<!--
 * @Description: 上工统计页面
 * @Author: sunhuihong
 * @Date: 2025-11-27 16:43:52
-->
<template>
  <div class="body" v-loading="loading" element-loading-text="正在导出...">
    <el-row class="search-row-margin" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="5" style="text-align: left;">
        <span class="search-title-wrap">机构名称：</span>
        <el-select v-model="filterParams.institutionId" style="width: 180px;" filterable clearable 
          remote placeholder="请输入并选择机构" size="small" :remote-method="loadInstList" 
          :loading="loadingInstList">
          <el-option v-for="inst in instList" :key="inst.id" size="small" :label="inst.name" 
            :value="inst.id"/>
        </el-select>
      </el-col>
      <el-col :span="6" style="text-align: center;">
				<span class="search-title-wrap">人员信息：</span>
				<el-input v-model="filterParams.nameOrMobileOrIdNo" size="small" clearable style="width: 180px;"
					placeholder="姓名/手机号/身份证号"></el-input>
			</el-col>
      <el-col :span="6" style="text-align: center;">
				<span class="search-title-wrap">日期：</span>
        <el-date-picker v-model="dateRange" style="width: 215px" type="daterange" align="right" unlink-panels 
          range-separator="至" size="small" start-placeholder="开始日期" end-placeholder="结束日期" 
          :picker-options="dateRangePickerOptions" prefix-icon="el-icon-date" :clearable="false"
          @change="datePickerChange" @blur="datePickerBlur">
        </el-date-picker>
      </el-col>
      <el-col :span="7" style="text-align: right;">
				<span class="search-title-wrap">当前状态：</span>
				<el-checkbox-group v-model="filterStatusList" :min="1" :max="3" style="display: inline-block"
          @change="changeStatusType">
          <el-checkbox v-for="(item, index) in statusList" :key="index" :label="parseInt(item.key)">
						{{item.value}}
					</el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>
    <el-row class="search-row-margin">
      <el-col :span="24" style="text-align: right">
        <el-button size="small" @click="handleSearch" type="primary" icon="el-icon-search" class="btn-search-w80">
			  	搜 索
			  </el-button>
        <el-button size="small" plain type="primary" class="btn-search-w80"
          style="background: #FEFFFF; color: #3E7EF5;"
          @click="handleExportDutyReport">
          <el-image :src="require('@/assets/common/icon-common-export.png')" fit="cover" 
            class="export-image">
          </el-image>
          导 出
        </el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>
    <el-table class="table-common-style" :style="tableWidth" :data="dataTable" 
      :header-cell-style="{'background-color': '#EFF5FA'}">
      <el-table-column label="所属机构" min-width="12%" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style">{{ scope.row.instName || '- -' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名" min-width="10%" align="left">
        <template slot-scope="scope">
          <span>{{scope.row.name || '- -'}}</span>
          <div class="sub-text-style">{{scope.row.mobile}}</div>
        </template>
      </el-table-column>
      <el-table-column label="身份证号" min-width="12%" align="left">
        <template slot-scope="scope">
          <span>{{scope.row.idNo || '- -'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="regTime" label="注册时间" sortable min-width="12%" align="left">
      </el-table-column>
      <el-table-column prop="statusText" label="当前状态" min-width="10%" align="left"></el-table-column>
      <el-table-column prop="totalIdleDaysText" label="总空闲 (天)" min-width="12%" align="left" sortable></el-table-column>
      <el-table-column prop="maxIdleDaysText" label="最长连续空闲 (天)" min-width="8%" align="left" sortable></el-table-column>
      <el-table-column prop="maxDutyDaysText" label="最长连续上工 (天)" min-width="8%" align="left" sortable></el-table-column>
      <el-table-column prop="lastDuty" label="最晚班次" min-width="10%" align="left"></el-table-column>
      <el-table-column label="操作" min-width="6%" align="left">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status != 3" type="text" size="small" @click="handleDetails(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber"/>
    </el-row>

    <!-- 详情弹框 -->
    <duty-details-dialog :visible="showDutyDetailsDialog" :filterParams="dutyDetailsParams"
      @close-dialog="showDutyDetailsDialog = false"/>
  </div>
</template>

<script>
import Util from "@/global/Util.js";
import Constant from "@/global/Constant.js";
import DutyDetailsDialog from "./components/DutyDetails.vue"

export default {
  name: "DutyReport",
  components: {
    'duty-details-dialog': DutyDetailsDialog
  },

  data() {
    return {
      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,
      dataTable: [],
      instList: [],
      loadingInstList: false,
      statusList: [],
      filterStatusList: [],

      dateRange: null,
      dateRangePickerOptions: {
        disabledDate: this.disabledDate,
        onPick: this.datePick,
        shortcuts: this.dateUtil.dateRangePickerOptions.shortcuts
			},
      pickDate: null,
      loading: false,

      //以下是上工详情弹框变量
      showDutyDetailsDialog: false,
      dutyDetailsParams: {},
    };
  },

  computed: {
    tableWidth() {
      return "width:" + (this.$root.contentWidth - 80) + "px";
    }
  },
  methods: {
    async initView() {
      this.dateRange = [this.dateUtil.getRecentDateStr(-30), this.dateUtil.getRecentDateStr(0)];
      this.$set(this.filterParams, 'startDate', this.dateRange[0]);
      this.$set(this.filterParams, 'endDate', this.dateRange[1]);
      await this.getDutyReportFilterDO();
      this.filterStatusList = [Number(this.statusList[0].key)];
      this.$set(this.filterParams, 'status', this.filterStatusList.join(","));
      this.pageDuties();
    },

    getDutyReportFilterDO() {
      return new Promise((resolve) => {
        let requestData = {
          method: "GET",
          url: Constant.URL_GET_DUTY_REPORT_FILYER_DO,
          param: null,
          contentType: this.commonConst.CNTYPE_URLENCODED
        }
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }
          this.instList = result.data.instList;
          this.statusList = this.commonUtil.map2List(result.data.statusMap);
          if (this.globalData.adminType == 2) {
            this.$set(this.filterParams, 'institutionId', this.instList[0].id);
          }
          resolve();
        })
      })
    },

    pageDuties() {
      let header = this.encryptionUtil.signatureParams(this.filterParams,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_PAGE_DUTIES,
        param: this.filterParams,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
     	this.vueRequest(requestData).then(result => {
				if (result == null) {
					return
				}
        this.dataTable = result.data;
        this.totalNumber = result.totalNumber;
      });
    },

    async loadInstList(filterStr) {
      this.loadingInstList = true;
      let filterParams = {filterStr: filterStr};
      this.instList = await Util.listTop30Institutions(filterParams, Constant.URL_GET_DUTY_REPORT_LIST_TOP_30INSTITUTIONS, this);
      this.loadingInstList = false;
    },

    datePickerChange() {
      this.filterParams.startDate = this.dateRange && this.dateRange.length 
        ? this.dateUtil.dateFormat(this.dateRange[0], 'YYYY-MM-DD') : '';
      this.filterParams.endDate = this.dateRange && this.dateRange.length 
        ? this.dateUtil.dateFormat(this.dateRange[1], 'YYYY-MM-DD') : '';
    },

    datePickerBlur() {
      this.pickDate = null;
    },

    disabledDate(date) {
      return Util.disabledDateByOneYear(date, this.pickDate);
    },

    datePick(pick) {
      this.pickDate = pick;
    },

    changeStatusType() {
			this.filterParams.status = this.filterStatusList.length ? this.filterStatusList.join(",") : '';
    },

    handleSearch() {
      this.filterParams.page = 1;
      this.pageDuties();
    },
    
    async handleExportDutyReport() {
      if (!this.filterParams.institutionId) {
        this.$message.error('请选择导出机构');
        return;
      }
      let param = {...this.filterParams}
      delete param.page
      delete param.pageSize
      let header = this.encryptionUtil.signatureParams(param,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      this.loading = true;
      await Util.exportExcel(Constant.URL_GET_EXPORT_DUTY_EXCEL, param, header)
      this.loading = false;
    },

    handleDetails(row) {
      this.$set(this.dutyDetailsParams, 'atdnId', row.atdnId);
      this.$set(this.dutyDetailsParams, 'startDate', this.filterParams.startDate);
      this.$set(this.dutyDetailsParams, 'endDate', this.filterParams.endDate);
      this.showDutyDetailsDialog = true;
      console.log(row)
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.pageDuties();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.pageDuties();
    },
  },

  mounted() {
    this.$emit("breadcrumb", { text1: "统计分析", text2: "上工统计" });
    this.initView();
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.export-image {
  width: 12px;
  height: 12px;
  vertical-align: bottom;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.sub-text-style {
  font-weight: 400;
  font-size: 12px;
  color: #606266;
  text-align: left;
}

.foot-pagination {
  margin-top: 20px;
  text-align: right;
  right: 22px;
  border: solid 0px;
}

.search-title {
  display: inline-block;
  color: #657180;
  font-size: 14px;
  text-align: right;
}

.overflow-text-style {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/report/DutyReport.vue